import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const FlagFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14.4 6 14 4H5v17h2v-7h5.6l.4 2h7V6z" fill="currentColor" />
  </svg>
);

FlagFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(FlagFilledIcon);
